import React from "react";
import "../assets/css/main.css";
import { Link } from "react-router-dom";
import GSC_LOGO_New from "../assets/images/GSC_Logo_new.png";

const Header = () => {
    return (
        <>
            <header className="header">
                <div className="head-top-main">
                    <div className="container-fluid">
                        <div className="d-flex justify-content-between">
                            <div className="header_logo">
                                <Link to={"/"} className="navbar-brand">
                                    <img src={GSC_LOGO_New} className="logo" alt="GSC Logo" />
                                </Link>
                                <div className="header_logo_text">
                                    <span>ગુજરાત રાજ્ય સંયુક્ત અને આરોગ્ય પરિષદ</span>
                                    <span className="mt-2 txt-orange">Gujarat State Allied and Healthcare Council</span>
                                </div>
                            </div>

                            <nav className="navbar navbar-expand-lg bg-body-tertiary">
                                <button
                                    className="navbar-toggler"
                                    type="button"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#offcanvasNavbar"
                                    aria-controls="offcanvasNavbar"
                                    aria-label="Toggle navigation"
                                    aria-expanded="false"
                                >
                                    <i className="fas fa-bars"></i>
                                </button>
                                <div
                                    className="offcanvas offcanvas-end"
                                    tabIndex="-1"
                                    id="offcanvasNavbar"
                                    aria-labelledby="offcanvasNavbarLabel"
                                >
                                    <div className="offcanvas-header">
                                        <div className="offcanvas-title" id="offcanvasNavbarLabel">
                                            <Link to={"/"}>
                                                <img
                                                    src={GSC_LOGO_New}
                                                    className="logo"
                                                    alt="GSC Logo"
                                                />
                                            </Link>
                                        </div>
                                        <button
                                            type="button"
                                            className="btn-close-mobile"
                                            data-bs-dismiss="offcanvas"
                                            aria-label="Close"
                                        >
                                            <i className="fa fa-times"></i>
                                        </button>
                                    </div>
                                    <div className="offcanvas-body">
                                        <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                                            <li className="nav-item">
                                                <Link
                                                    className="nav-link"
                                                    to={"/"}
                                                    data-bs-dismiss="offcanvas"
                                                >
                                                    Home
                                                </Link>
                                            </li>
                                            <li className="nav-item dropdown" style={{
                                                paddingRight: "15px",
                                            }
                                            }>
                                                <Link
                                                    className="nav-link dropdown-toggle"
                                                    id="navbarDropdownMenuLink"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    About
                                                </Link>
                                                <div
                                                    className="dropdown-menu"
                                                    aria-labelledby="navbarDropdownMenuLink"
                                                >
                                                    <Link
                                                        className="dropdown-item"
                                                        to={"/about-us"}
                                                        data-bs-dismiss="offcanvas"
                                                    >
                                                        About Us
                                                    </Link>
                                                    <Link
                                                        className="dropdown-item"
                                                        to={"/members"}
                                                        data-bs-dismiss="offcanvas"
                                                    >
                                                        Members
                                                    </Link>
                                                    <Link
                                                        className="dropdown-item"
                                                        to={"/professions"}
                                                        data-bs-dismiss="offcanvas"
                                                    >
                                                        Allied and Healthcare Professions
                                                    </Link>

                                                </div>
                                            </li>

                                            <li className="nav-item dropdown" style={{
                                                paddingRight: "15px",
                                            }
                                            }>
                                                <Link
                                                    className="nav-link dropdown-toggle"
                                                    id="navbarDropdownMenuLink"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    Useful Links
                                                </Link>
                                                <div
                                                    className="dropdown-menu"
                                                    aria-labelledby="navbarDropdownMenuLink"
                                                >
                                                    <Link
                                                        className="dropdown-item"
                                                        to="https://ncahp.abdm.gov.in"
                                                        target="_blank"
                                                        data-bs-dismiss="offcanvas"
                                                    >
                                                        National commision for Allied and Healthcare professions
                                                    </Link>
                                                    <Link
                                                        className="dropdown-item"
                                                        to="https://gujhealth.gujarat.gov.in"
                                                        target="_blank"
                                                        data-bs-dismiss="offcanvas"
                                                    >
                                                        Health and family welfare department - GOG
                                                    </Link>
                                                    <Link
                                                        className="dropdown-item"
                                                        to="https://www.medadmgujarat.org/ga/home.aspx"
                                                        data-bs-dismiss="offcanvas" target="_blank"
                                                    >
                                                        Admission Committee
                                                    </Link>

                                                </div>
                                            </li>
                                            <li className="nav-item">
                                                <Link
                                                    className="nav-link"
                                                    to={"/curriculums"}
                                                    data-bs-dismiss="offcanvas"
                                                >
                                                    Curriculum
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link
                                                    className="nav-link"
                                                    to={"/regulations"}
                                                    data-bs-dismiss="offcanvas"
                                                >
                                                    Regulations
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link
                                                    className="nav-link"
                                                    to={"/recruitment"}
                                                    data-bs-dismiss="offcanvas"
                                                >
                                                    Recruitment
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link
                                                    className="nav-link"
                                                    to={"/act-and-rules"}
                                                    data-bs-dismiss="offcanvas"
                                                >
                                                    Act & Rules
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;
